export default __webpack_public_path__ + "static/kathi_without_hand-cf95d713bc1fbccc853b8030b5016064.png";